import React, { useState, useEffect } from 'react';
import { AxiosInstance } from '../../../common/Loader/axios.config';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { IoClose } from 'react-icons/io5';

const UploadVideoModal = ({ isOpen, onClose, selectedSeries }) => {
    const [formData, setFormData] = useState({
        title: '',
        description: '',
        price: '',
        parent_content: '',
        video: null,
        thumbnail: null,
    });

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData({ ...formData, [name]: files[0] });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const formDataToSend = new FormData();
        Object.keys(formData).forEach(key => {
            if (formData[key]) {
                formDataToSend.append(key, formData[key]);
            }
        });
        formDataToSend.append('parent_content', selectedSeries?._id);

        console.log("Form Data:");
        for (let [key, value] of formDataToSend.entries()) {
            console.log(`${key}:`, value);
        }

        setLoading(true);

        AxiosInstance.post('/video-content', formDataToSend)
            .then(response => {
                if (response.data.status === "successful") {
                    const contentId = response.data.message._id;
                    Swal.fire({
                        icon: 'success',
                        title: 'Content Created successfully!',
                        text: `Content ID: ${contentId}`,
                        showConfirmButton: false,
                        timer: 2000,
                    });
                    onClose();
                }
            })
            .catch(error => {
                Swal.fire({
                    icon: 'error',
                    title: 'Upload Failed',
                    text: 'An error occurred while uploading.',
                });
                setLoading(false);
            });
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75">
            <div className="bg-brand-background rounded-lg p-6 w-1/2 relative">
                <button onClick={onClose} className="absolute top-4 right-4 text-white text-2xl">
                    <IoClose />
                </button>
                <h2 className="text-lg font-semibold mb-4 text-white">Upload Video to {selectedSeries?.title}</h2>
                <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-4">
                    <div>
                        <label className="block mb-2 text-white">Title</label>
                        <input
                            type="text"
                            name="title"
                            value={formData.title}
                            onChange={handleChange}
                            className="border border-brand-stroke-color rounded w-full p-2 bg-transparent text-white"
                            required
                        />
                    </div>
                    <div>
                        <label className="block mb-2 text-white">Description</label>
                        <textarea
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            className="border border-brand-stroke-color rounded w-full p-2 bg-transparent text-white"
                            required
                        />
                    </div>
                    <div>
                        <label className="block mb-2 text-white">Price</label>
                        <input
                            type="text"
                            name="price"
                            value={formData.price}
                            onChange={handleChange}
                            className="border border-brand-stroke-color rounded w-full p-2 bg-transparent text-white"
                            required
                        />
                    </div>
                    <div>
                        <label className="block mb-2 text-white">Video</label>
                        <input
                            type="file"
                            accept="video/*"
                            name="video"
                            onChange={handleFileChange}
                            className="border border-brand-stroke-color rounded w-full p-2 bg-transparent text-white"
                            required
                        />
                    </div>
                    <div>
                        <label className="block mb-2 text-white">Thumbnail</label>
                        <input
                            type="file"
                            accept="image/*"
                            name="thumbnail"
                            onChange={handleFileChange}
                            className="border border-brand-stroke-color rounded w-full p-2 bg-transparent text-white"
                            required
                        />
                    </div>
                    <div className="col-span-2">
                        <button type="submit" className="bg-primary text-white py-2 px-4 rounded">
                            {loading ? 'Uploading...' : 'Upload'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UploadVideoModal;
